import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import theme from "./theme";
import Header from "./components/Header";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import AdminLogin from "./pages/Admin/Login";
import AdminDashboard from "./pages/Admin/Dashboard";
import "./App.css";
import LoginView from "./section/login/login-view";
import DashboardLayout from "./layout/dashboard";
import AdminAnnouncements from "./section/announcement/user/view/user-view";
import AnnouncementsList from "./pages/AnnouncementsList";
import AnnouncementDetail from "./pages/AnnouncementDetail";
import TributesList from "./pages/TributesList";
import TributeDetail from "./pages/TributeDetail";
import BoardMembersList from "./pages/BoardMembersList";
import BoardMemberDetail from "./pages/BoardMemberDetail";
import About from "./section/about/user/view/user-view";
import Board from "./section/board/user/view/user-view";
import PhotoGallery from "./section/photogallary/user/view/user-view";
import Tributes from "./section/tributes/user/view/user-view";
import CreateBoard from "./section/board/Create";
import CreateTribute from "./section/tributes/Create";
import EditTribute from "./section/tributes/Edit";
import Slider from "./section/about/user/view/user-view";
import CreateSlider from "./section/about/Create";
import EditSlider from "./section/about/Edit";
import EditBoard from "./section/board/Edit";
import CreateAnnouncement from "./section/announcement/Create";
import EditAnnouncement from "./section/announcement/Edit";
import BecomeMember from "./section/become_member/user/view/user-view";
import CreateGellery from "./section/photogallary/Create";
import EditGallery from "./section/photogallary/Edit";
import ThemeProvider from "../src/theme";
import ByLaws from "./section/bylaws/user/view/user-view";
import CreateByLaws from "./section/bylaws/Create";
import ProxyFoam from "./section/proxyfoam/user/view/user-view";
import Users from "./section/users/view/users-view";
import MembershipForm from "./components/MembershipForm";
import ProxyForm from "./components/ProxyForm";
// import { DashboardLayout } from "./layout/adminlayout";
// import Announcements from "./components/Announcements";
// import About from "./components/About";
// import BoardMembers from "./components/BoardMembers";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app">
          <Routes>
            <Route
              path="/"
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />
            {/* <Route
              path="/admin"
              element={
                <Layout>
                  <AdminLogin />{" "}
                </Layout>
              }
            /> */}
            <Route
              path="/admin/*"
              element={
                <Layout>
                  <AdminDashboard />
                </Layout>
              }
            />
            <Route path="/admin" element={<LoginView />} />
            <Route
              path="/announcements"
              element={
                <Layout>
                  <AnnouncementsList />
                </Layout>
              }
            />
            <Route
              path="/announcements/:id"
              element={
                <Layout>
                  <AnnouncementDetail />
                </Layout>
              }
            />
            <Route
              path="/tributes"
              element={
                <Layout>
                  <TributesList />
                </Layout>
              }
            />
            <Route
              path="/tributes/:id"
              element={
                <Layout>
                  <TributeDetail />
                </Layout>
              }
            />
            <Route
              path="/board-members"
              element={
                <Layout>
                  <BoardMembersList />
                </Layout>
              }
            />
            <Route
              path="/board-members/:id"
              element={
                <Layout>
                  <BoardMemberDetail />
                </Layout>
              }
            />
            <Route
              path="/admin/announcements"
              element={
                <DashboardLayout>
                  <AdminAnnouncements />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/announcements/CreateAnnouncement"
              element={
                <DashboardLayout>
                  <CreateAnnouncement />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/announcements/EditAnnouncement/:id"
              element={
                <DashboardLayout>
                  <EditAnnouncement />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/becomeMember"
              element={
                <DashboardLayout>
                  <BecomeMember />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/users"
              element={
                <DashboardLayout>
                  <Users />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/slider"
              element={
                <DashboardLayout>
                  <Slider />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/slider/CreateSlider"
              element={
                <DashboardLayout>
                  <CreateSlider />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/slider/EditSlider/:id"
              element={
                <DashboardLayout>
                  <EditSlider />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/board"
              element={
                <DashboardLayout>
                  <Board />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/board/CreateBoard"
              element={
                <DashboardLayout>
                  <CreateBoard />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/board/EditBoard/:id"
              element={
                <DashboardLayout>
                  <EditBoard />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/photoGallery"
              element={
                <DashboardLayout>
                  <PhotoGallery />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/photoGallery/CreateGellery"
              element={
                <DashboardLayout>
                  <CreateGellery />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/photoGallery/EditGallery/:id"
              element={
                <DashboardLayout>
                  <EditGallery />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/tributes"
              element={
                <DashboardLayout>
                  <Tributes />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/tributes/CreateTribute"
              element={
                <DashboardLayout>
                  <CreateTribute />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/tributes/EditTribute/:id"
              element={
                <DashboardLayout>
                  <EditTribute />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/ByLaws"
              element={
                <DashboardLayout>
                  <ByLaws />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/ByLaws/CreateByLaws"
              element={
                <DashboardLayout>
                  <CreateByLaws />
                </DashboardLayout>
              }
            />
            <Route
              path="/admin/Proxy_foam"
              element={
                <DashboardLayout>
                  <ProxyFoam />
                </DashboardLayout>
              }
            />
            <Route
              path="/membership-application"
              element={<MembershipForm />}
            />
            <Route
              path="/proxy-form"
              element={<ProxyForm />}
            />
          </Routes>
        </div>
        <ToastContainer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
